import { useChangeSearch, useSearch } from '@btime/react-contexts'
import React from 'react'

import { Text } from '../../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import GroupsLoader from '../../_load/GroupsLoader'
import SearchInput from '../../../../components/form/SearchInput'
import SelectAllSwitch from '../../../../components/form/SelectAllSwitch'
import Separator from '../../../../components/helpers/Separator'
import ToRight from '../../../../components/helpers/ToRight'

const ControlBar = ({ selectedLabel, useSelectAll, header, disabledLoader, ...props }) => {
  const changeSearch = useChangeSearch()
  const search = useSearch()

  const rightComponent = useSelectAll && <SelectAllSwitch value={props.value} onChange={props.onChange} />

  return (
    <div>
      <FlexGrid justify="space-between" gutter={0.5}>
        <FlexCol flex={1}>
          <SearchInput onStopTyping={changeSearch} value={search} />
        </FlexCol>
        {header && <FlexCol flex={1}>{header}</FlexCol>}
        {rightComponent && (
          <>
            <FlexCol flex={1} hideOn="sm" />
            <FlexCol flex={1}>
              <ToRight>{rightComponent}</ToRight>
            </FlexCol>
          </>
        )}
      </FlexGrid>

      <Separator weight={4} />

      <FlexGrid align="flex-start" justify="flex-start" gutter={0.2}>
        <Text>{selectedLabel ? 'Selecionado' : 'Selecione um'}: </Text>
        <Text inlineBlock bold>
          {selectedLabel}
        </Text>
      </FlexGrid>

      <Separator weight={4} />

      <GroupsLoader search={search} disabled={disabledLoader} {...props} />
    </div>
  )
}

export default ControlBar
